interface KoyoBrandingProps {
  variant?: 'light' | 'dark';
  className?: string;
}

export function KoyoBranding({ variant = 'dark', className = '' }: KoyoBrandingProps) {
  return (
    <div className={`text-center ${className}`}>
      <p className={`text-xs ${variant === 'light' ? 'text-slate-300' : 'text-slate-500'}`}>
        Powered by <span className="font-semibold text-emerald-500">Koyo Healthtech</span>
      </p>
    </div>
  );
}
